<div class="container">
  <div class="left_noticia" *ngIf="article">
    <div class="info_noticia" [appMark]="configMark">
      <div class="fecha">{{ article.date }}</div>

      <h2
        [innerHTML]="
          article.title
            | highlightKeywords: keywordsArray
            | highlightSearch: search
        "
      ></h2>

      <div class="imagen">
        <img
          src="{{ article.image }}"
          onerror="this.src='/assets/images/image-not-found.jpg'"
        />
        <div class="noticia__logo" *ngIf="origin?.logo">
          <img [src]="origin?.logo" />
        </div>
      </div>
      <p>
        Más artículos de
        <a
          [routerLink]="['/noticias/']"
          [queryParams]="{ pages: origin?.id }"
          class="readmore boton"
          >{{ origin?.name }}</a
        >
      </p>

      <div class="cuerpo">
        <p *ngIf="article.description">
          {{ article.description }}
        </p>

        <p
          *ngFor="let text of article.texts"
          [innerHTML]="
            text | highlightKeywords: keywordsArray | highlightSearch: search
          "
        ></p>
      </div>
    </div>

    <a href="{{ article.url }}" class="open_original" target="_blank"
      >Abrir Artículo original</a
    >
  </div>
  <div class="right_noti">
    <h3>Noticias Recientes</h3>

    <div *ngFor="let item of articles" class="noticia">
      <a class="article_open" (click)="goArticle(item._id)">
        <div class="info_noti">
          <div class="fecha">{{ item.date }}</div>

          <div
            class="title"
            [innerHTML]="
              item.title
                | highlightKeywords: keywordsArray
                | highlightSearch: search
            "
          ></div>

          <div class="boton">Ver más</div>
        </div>
      </a>
    </div>
    <section class="ads">
      <a
        *ngFor="let img of bannerImages"
        href="https://tienda.elgreenpost.com/"
        class="ads_banners"
        [innerHTML]="img.content.rendered"
      ></a>
    </section>
  </div>

  <div class="clr"></div>
</div>
